import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useBankIdProfile } from './useBankIdProfile';
import { IS_SWEDEN } from '@/constants/constants';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function useUpdateContactInfoToast(addToastCallback, cleanupToastCallback) {
  const intl = useIntl();
  const { openModal } = useModal();
  const TOAST_ID = 'UPDATE_USER_DETAILS_TOAST';
  const { isCompletedBankIdProfile } = useBankIdProfile();

  const openContactInfoModal = () => {
    IS_SWEDEN ? openModal(MODALS.CONTACT_INFO_SWEDEN) : openModal(MODALS.CONTACT_INFO);
  };

  useEffect(() => {
    if (isCompletedBankIdProfile) {
      cleanupToastCallback(TOAST_ID);
      return;
    }

    const toast = {
      id: TOAST_ID,
      order: 1,
      subtitle: intl.formatMessage({ id: 'notification.updateUserDetails' }),
      cta: intl.formatMessage({ id: 'misc.update' }),
      clickCallback: openContactInfoModal,
    };
    addToastCallback(toast);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompletedBankIdProfile]);
}
